import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColGroupDef } from "ag-grid-enterprise";
import { Phase } from "../../../../models/eaf.models";
const moment = getMomentTz();
export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Phases",
			headerStyle: {
				fontSize: "0.9rem",
			},
			children: [
				{
					field: "PhaseName",
					headerName: "Phase Name",
					flex: 2,
					minWidth: 120,
					valueGetter: (params: any) => {
						return (params.data as Phase).PhaseName;
					},
				},
				{
					field: "Start",
					headerName: "Start",
					flex: 1,
					minWidth: 81,
					valueGetter: (params: any) => {
						if (params.data.Start) {
							return dxtToLocalServerTime(
								(params.data as Phase).Start,
								"HH:mm:ss",
							);
						}
					},
				},
				{
					field: "End",
					headerName: "End",
					flex: 1,
					minWidth: 81,
					valueGetter: (params: any) => {
						if (params.data.End) {
							return dxtToLocalServerTime(
								(params.data as Phase).End,
								"HH:mm:ss",
							);
						}
					},
				},
				{
					field: "Duration",
					headerName: "Duration",
					flex: 1,
					minWidth: 85,
					valueGetter: (params: any) => {
						const { Start, End } = params.data as Phase;

						if (End && Start) {
							const durationInSeconds = moment(End).diff(
								moment(Start),
								"seconds",
							);
							const minutes = Math.floor(durationInSeconds / 60);
							const seconds = durationInSeconds % 60;
							return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
						}
					},
				},
				{
					field: "Energy",
					headerName: "Energy [kwh]",
					flex: 1,
					minWidth: 60,
					wrapHeaderText: true,
					headerStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						const energy = (params.data as Phase).Energy;
						return energy || " ";
					},
				},
			],
		},
	];

	return { columns };
};
